import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDeviceVideoFleetSettings } from '../../services/VideoService';
import { DeviceVideoSettingsPayload, DeviceVideoSettingsResponse } from '../../types/Videos';

type Result = UseMutationResult<DeviceVideoSettingsResponse, Error, DeviceVideoSettingsPayload>;

function usePostDeviceVideoFleetSettings(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postDeviceVideoFleetSettings, {
    onSuccess: () => {
      successCb();
      // queryClient.invalidateQueries({ queryKey: ['device-video-settings'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDeviceVideoFleetSettings;
